import ActivityFeature from "@/features/Activities";

export default function ActivityPage() {
  return (
    <main className="md:w-[80vw] lg:w-[70vw] mx-auto ">
      <ActivityFeature />
    </main>
  );
}
